[
  { "label": "Čeština", "code": "cs", "english": "Czech", "production": false },
  { "label": "Deutsch", "code": "de", "english": "German", "production": true },
  {
    "label": "English",
    "code": "en",
    "english": "English",
    "production": true
  },
  {
    "label": "Español, Castellano",
    "code": "es",
    "english": "Spanish, Castilian",
    "production": true
  },
  {
    "label": "Français",
    "code": "fr",
    "english": "French",
    "production": true
  },
  {
    "label": "Italiano",
    "code": "it",
    "english": "Italian",
    "production": true
  },
  {
    "label": "Lietuvių",
    "code": "lt",
    "english": "Lithuanian",
    "production": false
  },
  {
    "label": "Norsk bokmål",
    "code": "nb",
    "english": "Norwegian (bokmål)",
    "production": true
  },
  { "label": "Polski", "code": "pl", "english": "Polish", "production": true },
  {
    "label": "Português",
    "code": "pt",
    "english": "Portuguese",
    "production": true
  },
  {
    "label": "Português (Brasil)",
    "code": "pt_BR",
    "english": "Portuguese (Brazil)",
    "production": true
  },
  { "label": "Suomi", "code": "fi", "english": "Finnish", "production": false },
  {
    "label": "Svenska",
    "code": "sv",
    "english": "Swedish",
    "production": true
  },
  {
    "label": "Ελληνικά",
    "code": "el",
    "english": "Greek",
    "production": false
  },
  {
    "label": "Русский",
    "code": "ru",
    "english": "Russian",
    "production": true
  },
  {
    "label": "Українська",
    "code": "uk",
    "english": "Ukrainian",
    "production": true
  },
  {
    "label": "עִבְרִית",
    "code": "he",
    "english": "Hebrew",
    "production": true
  },
  {
    "label": "Türkçe",
    "code": "tr",
    "english": "Turkish",
    "production": false
  },
  {
    "label": "Slovenščina",
    "code": "sl",
    "english": "Slovene",
    "production": false
  },
  {
    "label": "Română",
    "code": "ro",
    "english": "Romanian",
    "production": false
  },
  {
    "label": "Bahasa Indonesia",
    "code": "id",
    "english": "Indonesian",
    "production": true
  },
  {
    "label": "Magyar",
    "code": "hu",
    "english": "Hungarian",
    "production": false
  },
  {
    "label": "Nederlands",
    "code": "nl",
    "english": "Dutch",
    "production": true
  },
  {
    "label": "简体中文",
    "code": "zh_Hans",
    "english": "Chinese (simplified)",
    "production": true
  },
  {
    "label": "日本語",
    "code": "ja",
    "english": "Japanese",
    "production": false
  },
  {
    "label": "اَلْعَرَبِيَّةُ",
    "code": "ar",
    "english": "Arabic",
    "production": false
  },
  {
    "label": "Hhrvatski",
    "code": "hr",
    "english": "Croatian",
    "production": false
  },
  {
    "label": "Latviešu",
    "code": "lv",
    "english": "Latvian",
    "production": false
  },
  {
    "label": "Srpski (latinica)",
    "code": "sr",
    "english": "Serbian",
    "production": false
  },
  {
    "label": "Slovenščina",
    "code": "sl",
    "english": "Slovenian",
    "production": false
  },
  {
    "label": "Català",
    "code": "ca",
    "english": "Catalan",
    "production": false
  },
  {
    "label": "हिन्दी",
    "code": "hi",
    "english": "Hindi",
    "production": true
  }
]
